import angular from 'angular';

function RevenueFormatterService(CURRENCY_CODES, FormatterService) {
    const getFormatters = (data) => {
        const currencyCode = getCurrencyCode(data);
        const currencyFormatter = resolveCurrencyFormatter(currencyCode);
        // eslint-disable-next-line no-undef
        const dateFormatter = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
        });

        return { currencyFormatter, dateFormatter };
    };

    const resolveCurrencyFormatter = currencyCode => FormatterService.getCurrencyFormatter(currencyCode);

    const getCurrencyCode = (data = []) => {
        if (data.length) {
            return data[0].currencyCode;
        }
    };

    return {
        getFormatters,
    };
}

angular.module('TALENYA-FE').factory('RevenueFormatterService', RevenueFormatterService);
